import { NsInputterValidations } from 'components/common/ns-inputter/NsInputterValidations';
import { NsTextInput } from 'components/common/ns-text-input/NsTextInput';
import NsInputterEvent from '../ns-inputter/NsInputterEvent';

type NsFirstNameInputProps = {
  id?: string;
  label?: string;
  name?: string;
  testId?: string;
  onChange?: (event: NsInputterEvent) => void;
  value?: string;
  inputAttributes?: Record<string, string | boolean>;
};

export const NsFirstNameInput = ({
  id = 'firstName',
  name = 'firstName',
  label = 'First name',
  value,
  testId,
  onChange,
  inputAttributes = {}
}: NsFirstNameInputProps) => {
  const validations = [
    NsInputterValidations.isRequired,
    NsInputterValidations.isFirstName,
    NsInputterValidations.minLength('2')
  ];
  return (
    <NsTextInput
      id={id}
      testId={testId}
      validation={validations}
      value={value}
      label={label}
      name={name}
      inputAttributes={inputAttributes}
      onChange={onChange}
    />
  );
};
